var $b7c373369fd58b60$exports = {};
$b7c373369fd58b60$exports = {
    "maximum": `Maksim\u{101}l\u{101} v\u{113}rt\u{12B}ba`,
    "minimum": `Minim\u{101}l\u{101} v\u{113}rt\u{12B}ba`
};


export {$b7c373369fd58b60$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
